module.exports = __webpack_public_path__ + "img/wind.7e4ed097.png";